(function () {
    'use strict';

    angular.module("imApp").factory("priceService", ['$ihttp', function ($ihttp) {
        let service = {
            getPrice: function (parms) {
                return $ihttp.post({
                    method: 648,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 649,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 651,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
